const { showError, showNotifikasi } = require('../../libs/helper');
var qs = require('qs');

module.exports = {
  getData: (g, params) => {
    const result = g.$http({
      //nanti ganti end point
      url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/perkin/list',
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((res) => {
      return res.data;
    }

    ).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
  getDetailPerkin: (g, params) => {
    const result = g.$http({
      url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/perkin/detail',
      method: 'post',
      data: qs.stringify(params),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(res => res.data).catch(err => {
      showError(g, err, 'Error Get Data')
    })
    return result
  },
}